module.exports = __webpack_public_path__ + "media/images/WFC_Landscape_Black_w_0-59c07a198b2d498b47a9360cb8e53634.svg";